import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { parse } from 'query-string';
import { Page, Row, Column } from 'components/shared/Layout';
import { Spinner } from 'admin-components/components';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { SEARCH_DISCOUNT_CODES } from 'store/queries';
import { StyledH1, StyledH2 } from './DiscountCodeList.styles';
import DiscountCodesTable from './DiscountCodesTable';

const DiscountCodeList = ({ location: { search } }) => {
  const { validTravelDate, validSalesDate } = parse(search);
  const { loading, error, data } = useQuery(SEARCH_DISCOUNT_CODES, {
    variables: {
      validTravelDate,
      validSalesDate
    },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return (
      <Row span={16} height="100vh">
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/discountCodes/manage'
    });
  }

  const { searchDiscountCodes: discountCodes } = data;

  return (
    <Page columns={20}>
      <Column span={18} start={2}>
        <StyledH1>
          <FormattedMessage id="discountCodes.manageDiscountCode" />
        </StyledH1>
        <StyledH2>
          <FormattedMessage
            id="discountCodes.searchByDateResultsHeader"
            values={{
              numberOfDiscountCodes: discountCodes.length,
              salesDate: validSalesDate || '-',
              travelDate: validTravelDate || '-'
            }}
          />
        </StyledH2>
        <DiscountCodesTable discountCodes={discountCodes} />
      </Column>
    </Page>
  );
};

DiscountCodeList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default withRouter(DiscountCodeList);
